import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import axios from "../../util/axios";
import { Context } from "../../component/Context/ErrorContext";

const Dashboard = () => {
  const { setError } = useContext(Context);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const getDashBoardData = async () => {
    setLoading(true);
    axios({
      URL: "/omw/get-aggregate-data",
      method: "GET",
    })
      .then((res) => {
        setDashboardData(res?.data?.data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getDashBoardData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Dashboard</p>
      <div className={"w-full bg-grayLight h-1 my-2"} />
      <div className={"flex gap-4 mt-2 w-full flex-col md:flex-row"}>
        <div
          className={
            "bg-secondary p-2 w-full flex flex-col items-start md:w-1/2"
          }
        >
          <p className={"text-white"}>Real Time</p>
          <div className={"w-full bg-lightBlue p-4 mt-3 flex flex-col gap-10"}>
            <div
              className={
                "grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-4"
              }
            >
              <div className={"flex flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.user_count || 0}
                </p>
                <p className={"text-white text-sm"}>User Count</p>
              </div>
              <div className={"flex flex-col items-center min-w-max"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.referral_count || 0}
                </p>
                <p className={"text-white text-sm"}>Referral Count</p>
              </div>
              <div className={"flex flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {Math.round(dashboardData?.male_percentage * 100) / 100 || 0}{" "}
                  %
                </p>
                <p className={"text-white text-sm"}>Male Percentage</p>
              </div>
              <div className={"flex flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {Math.round(dashboardData?.female_percentage * 100) / 100 ||
                    0}{" "}
                  %
                </p>
                <p className={"text-white text-sm"}>Female Percentage</p>
              </div>
            </div>
            <div
              className={"grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2"}
            >
              <div className={"flex flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.distance_travelled || 0}
                </p>
                <p className={"text-white text-sm"}>Distance Travelled</p>
              </div>
              <div className={"file flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.total_earned || 0}
                </p>
                <p className={"text-white text-sm"}>Total Earned</p>
              </div>
            </div>
            <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2"}>
              <div className={"flex flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.daily_active_users || 0}
                </p>
                <p className={"text-white text-sm"}>Daily Active Users</p>
              </div>
              <div className={"file flex-col items-center"}>
                <p className={"text-green text-base xl:text-lg font-bold"}>
                  {dashboardData?.monthly_active_users || 0}
                </p>
                <p className={"text-white text-sm"}>Monthly Active Users</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            "bg-secondary p-2 w-full flex flex-col items-start md:w-1/2"
          }
        >
          <p className={"text-white"}>User Location</p>
          <div
            className={"w-full h-full bg-lightBlue p-4 mt-3 flex flex-col"}
          ></div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default Dashboard;
